import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormikErrors, FormikValues } from "formik";
import { setFormLoading } from "../../../../actions/diversityFormActions";
import loader from "../../../shared/loaders/img/spinner-white.gif";
import { AppState } from "../../../../store";
import {
  Button,
  DisabledButton,
  Spinner,
} from "../../styles/diversity-form-styles";

export interface ISubmitButtonProps {
  caringResponsibilities?: string;
  caringResponsibilitiesType?: string;
  errors: FormikErrors<FormikValues>;
  setFormLoadingAction: typeof setFormLoading;
  formLoading: boolean;
}

export const SubmitButton: FunctionComponent<ISubmitButtonProps> = ({
  caringResponsibilities,
  caringResponsibilitiesType,
  errors,
  setFormLoadingAction,
  formLoading,
}) => {
  if (
    caringResponsibilities === "No" &&
    !errors.caringResponsibilities &&
    !errors.caringResponsibilitiesType &&
    !errors.recaptcha
  ) {
    return (
      <Button
        type="submit"
        formLoading={formLoading}
        onClick={setFormLoadingAction}
        data-test-id="submit-button"
      >
        {formLoading ? (
          <Spinner src={loader as string} alt="Spinner" />
        ) : (
          "Submit"
        )}
      </Button>
    );
  }
  if (
    caringResponsibilities === "Yes" &&
    caringResponsibilitiesType &&
    !errors.caringResponsibilities &&
    !errors.caringResponsibilitiesType &&
    !errors.recaptcha
  ) {
    return (
      <Button
        type="submit"
        formLoading={formLoading}
        onClick={setFormLoadingAction}
        data-test-id="submit-button"
      >
        {formLoading ? (
          <Spinner src={loader as string} alt="Spinner" />
        ) : (
          "Submit"
        )}
      </Button>
    );
  }
  return <DisabledButton type="button">Submit</DisabledButton>;
};

SubmitButton.propTypes = {
  caringResponsibilities: PropTypes.string,
  caringResponsibilitiesType: PropTypes.string,
  errors: PropTypes.shape({
    caringResponsibilities: PropTypes.string,
    caringResponsibilitiesType: PropTypes.string,
    recaptcha: PropTypes.string,
  }).isRequired,
  setFormLoadingAction: PropTypes.func.isRequired,
  formLoading: PropTypes.bool.isRequired,
};

SubmitButton.defaultProps = {
  caringResponsibilities: null,
  caringResponsibilitiesType: null,
};

const mapStateToProps = (state: AppState) => ({
  formLoading: state.diversityForm.formLoading,
});

export default connect(mapStateToProps, {
  setFormLoadingAction: setFormLoading,
})(SubmitButton);
